import $ from 'jquery';

import BaseController from 'chairisher/_controller';
import Carousel from 'chairisher/component/carousel';
import DoesShipToYou from 'chairisher/view/product/doesshiptoyou';
import FavoriteProductView from 'chairisher/view/product/favorite';
import FolderCardMenu, { FolderCardTransitionAnimations } from 'chairisher/component/card/foldercardmenu';
import FormFieldComponent from 'chairisher/component/form/field';
import FormUtils from 'chairisher/util/form';
import HistoryUtils from 'chairisher/util/history';
import ImageViewer from 'chairisher/view/imageviewer';
import LocationPopoverComponent from 'chairisher/component/geo/locationpopover';
import NavigationView from 'chairisher/view/navigation';
import ProductModel from 'chairisher/model/product';
import QuantityField from 'chairisher/component/form/fieldquantity';
import RecommendedOffersView, { bindMAORedirectModal } from 'chairisher/view/product/recommendedoffers';
import ReferrerUtils from 'chairisher/util/referrer';
import SampleDetailModal from 'chairisher/component/modal/sampledetail';
import ShippingOptionField from 'chairisher/component/form/fieldshippingoption';
import SocialShare from 'chairisher/view/socialshare';
import TooltipHelper from 'chairisher/view/helper/tooltip';
import ViewportUtil from 'chairisher/util/viewport';

import bindAddToCart from 'chairisher/view/product/addtocart';
import bindHoldForm from 'chairisher/view/product/hold';
import bindSellerReviews from 'chairisher/view/sellerreviews';
import createProductRail from 'chairisher/view/helper/rail';
import getTradeInsuranceProgramBenefits from 'chairisher/context/trade';
import trackContentVisibility from 'chairisher/analytics/content';
import trackLocationSearchEvent from 'chairisher/analytics/location';
import zendeskWebWidgetInst from 'chairisher/component/zendesk';

import { trackAddToCart } from 'chairisher/analytics/cart';
import { trackMaoModalOpen } from 'chairisher/analytics/checkout';
import { trackHoldRequestCreate, trackHoldRequestShow } from 'chairisher/analytics/dealer';
import {
    getAmplitudeEventPropertiesForProductDetailsSection,
    logSustainabilityShowEvent,
} from 'chairisher/analytics/product';
import { trackProductDetailPageview, trackProductShippingChanged } from 'chairisher/analytics/product/detail';
import { SellerReviewsSubType, trackSellerReviewsClickEvent } from 'chairisher/analytics/sellerreviews';
import { getGuid, getQuickCreateUrl, isAuthenticated, isStaff, setTradeAuthCallback } from 'chairisher/context/auth';
import { getCompleteTheLookUrl } from 'chairisher/context/collection';
import { canLoadAdvertisingCookies } from 'chairisher/context/cookies';
import { getAmplitudeExperimentFlagMap } from 'chairisher/context/experiments';
import { getShippableCountryByCode, isUserInCountryWeShipTo } from 'chairisher/context/location';
import {
    getDataForVariantId,
    getFavoriteCreateUrl,
    getImageViewerIndicatorSrcsets,
    getImageViewerSrcsets,
    getMaoRedirectKey,
    getMoreFromThisSellerUrl,
    getMoreLikeThisUrl,
    getProductId,
    getProductLineUrl,
    getProductObject,
    getRecentlyViewedUrl,
    getShippingOptionsUrl,
    getTastemakerUrl,
    getYmalUrl,
} from 'chairisher/context/product';
import { getPromotedListingsUrl } from 'chairisher/context/promotedlistings';
import { isLiveChatActive } from 'chairisher/context/site';
import { formatInNumCartsString, formatUrgencyCount } from 'chairisher/experiments/incarturgency';
import { exposeExperiment, isExperimentVariantB, isExperimentVariantC } from 'chairisher/thirdparty/experiments';
import { trackPageVisitForPRT } from 'chairisher/thirdparty/pinterestretargeting';
import { syncListAriaHidden } from 'chairisher/util/accessibility';
import {
    AmplitudeEventProperty,
    BuyerSellerCommunicationPosition,
    GlobalPosition,
    PDPSection,
    ProductRailPosition,
    ProductRailSubType,
    ProductRailType,
    TrackingAction,
    TrackingLabel,
    TrackingScreen,
    logAmplitudeButtonClickEvent,
    logAmplitudeClickEvent,
    logAmplitudeEvent,
} from 'chairisher/util/analytics';
import { partialToggle } from 'chairisher/util/collapse';
import { getJSON } from 'chairisher/util/fetch';
import { handleAsyncError } from 'chairisher/util/logging';
import { isMaxMediumDesktop, isTouchDevice, prefersReducedMotion } from 'chairisher/util/mediaquery';
import { fetchProduct } from 'chairisher/util/productdata';
import { renderAjaxErrorAlert } from 'chairisher/util/response';
import { isUnauthorized } from 'chairisher/util/status';
import { renderProductDisclaimers } from 'chairisher/view/product/disclaimers';
import { PrivateDealSource, renderPrivateDeal } from 'chairisher/view/product/privatedeal';

const { LocationPopover, LocationPopoverEvents } = LocationPopoverComponent;

/**
 * The controller that binds actions related to the Product Detail Page
 */
class ProductDetailController extends BaseController {
    /** @inheritDoc */
    initControllerState() {
        super.initControllerState();

        /**
         * @type {ProductModel}
         */
        this.product = new ProductModel(getProductObject());
        this.product.setWebUrl(document.location.pathname);

        /**
         * The FolderCardMenu for the main product on the PDP
         *
         * @type {FolderCardMenu}
         */
        this.folderCardMenu = null;

        setTradeAuthCallback(() => {
            const product = new ProductModel(getProductObject());
            fetchProduct(product.getId()).then((productData) => {
                if (productData) {
                    this.toggleTradeInsuranceUIComponents(productData);
                }
            }, handleAsyncError);
        });
    }

    /** @inheritDoc * */
    bindChairishActions() {
        if (isMaxMediumDesktop() && ReferrerUtils.isOrganicReferrer()) {
            const $promoBanner = $('#js-promo-banner');
            $promoBanner.find('.js-scroller').remove();
            $promoBanner.height('auto');
        }

        const productModel = new ProductModel(getProductObject());

        // add recently viewed rail
        const rvProductsIdSelector = '#js-recently-viewed';
        createProductRail({
            $containerEl: $(rvProductsIdSelector),
            $el: $(`${rvProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.BOTTOM,
            analyticsTrackingType: ProductRailType.RECENTLY_VIEWED,
            listSelector: rvProductsIdSelector,
            railUrl: getRecentlyViewedUrl(),
        });

        $('.js-seller-award').tooltip({
            trigger: 'hover focus',
            placement: TooltipHelper.getPlacement,
        });
        $('.js-made-to-order-info').tooltip({ placement: TooltipHelper.getPlacement });

        //
        // Details Binding
        //
        const $infoDetails = $('#js-info-details');
        const $productInfo = $infoDetails.closest('.js-product-info');
        const $productDescription = $productInfo.find('.js-product-description');
        const $descriptionToggleMore = $productDescription.find('.js-toggle-more');
        const $descriptionToggleLess = $productDescription.find('.js-toggle-less');

        const $infoShipping = $infoDetails.find('#js-info-shipping');
        const $shippingSectionBtn = $infoShipping.siblings('.js-shipping-section-btn');

        // toggles the details section on any click except for those on nested links, submit buttons, or targets with specified parents
        $productInfo.on('click', (e) => {
            e.stopPropagation();
            const $target = $(e.target);

            const $nonToggleParent = $target.closest('#js-info-shipping, .js-shop-sustainably-link');
            if (!$target.attr('href') && $target.prop('type') !== 'submit' && !$nonToggleParent.length) {
                partialToggle('#js-info-details');
            }
        });

        // expanding and collapsing the details section will also expand and collapse the product description
        $infoDetails.on('hidden.bs.collapse shown.bs.collapse', (e) => {
            if ($(e.target).attr('id') !== $infoShipping.attr('id')) {
                const isShown = e.type === 'shown';
                $descriptionToggleMore.toggleClass('hidden', isShown);
                $descriptionToggleLess.toggleClass('hidden', !isShown);
            }
        });

        // expanding the product description will also expand the details section
        $descriptionToggleMore.find('.js-swap-trigger').on('click', (e) => {
            e.preventDefault();
            if (!$infoDetails.hasClass('in')) {
                partialToggle('#js-info-details');
            }
        });

        $shippingSectionBtn.on('click', (e) => {
            if ($infoDetails.hasClass('in')) {
                e.stopPropagation();
                $infoShipping.collapse('toggle');
            } else {
                $infoShipping.collapse('show');
            }
        });

        //
        // Anchor Binding - navigates to and expands section when anchor tag is present
        //
        ['details', 'shipping'].forEach((sectionName) => {
            const sectionIdSelector = `#product-info-${sectionName}-section`;
            if (window.location.hash === sectionIdSelector) {
                const $section = $(sectionIdSelector);
                if ($section.length > 0) {
                    $section.find(`button[data-target="#js-info-${sectionName}"]`).trigger('click');
                }
            }
        });

        //
        // Seller Reviews Binding
        //
        $('.js-seller-reviews-link').on('click', (e) => {
            e.preventDefault();
            NavigationView.scrollToElement($('#seller-reviews'));
            trackSellerReviewsClickEvent(
                SellerReviewsSubType.RATING_STARS,
                PDPSection.REVIEWS_LINK,
                $(e.currentTarget).attr('href'),
            );
        });

        //
        // Estimated Arrival Binding
        //
        const $arrivalInfoLink = $('.js-arrival-info-link');
        if ($arrivalInfoLink.length) {
            $arrivalInfoLink.on('click', (e) => {
                e.preventDefault();

                if (!$infoDetails.hasClass('in')) {
                    partialToggle('#js-info-details');
                }
                $infoShipping.collapse('show');

                setTimeout(() => {
                    window.location.href = $(e.currentTarget).attr('href');
                }, 500);
            });
        }

        const $arrivalInfoTooltip = $('.js-arrival-info-tooltip');
        if ($arrivalInfoTooltip.length) {
            $arrivalInfoTooltip.tooltip({ placement: TooltipHelper.getPlacement });
        }

        const $purchaseActions = $('.js-purchase-actions');

        bindAddToCart({
            $cartForm: $purchaseActions.find('.js-buy-now-form'),
            onSuccess: (quantity) => {
                trackAddToCart(productModel, PDPSection.PDP, quantity, {
                    [AmplitudeEventProperty.IS_IN_OTHER_CARTS]: !!this.numOtherCartsIn,
                });
            },
        });

        bindHoldForm($purchaseActions, () => {
            trackHoldRequestCreate(productModel, PDPSection.PDP);
            window.location.reload();
        });

        const searchParams = new URLSearchParams(window.location.search);
        const privateDealId = searchParams.get('private_deal_id');

        const productId = productModel.getId();
        const $recommendedOfferModal = $('#js-mao-modal');

        new RecommendedOffersView({
            $el: $('.js-offer-recommendation-pdp'),
            privateDealId,
            productId,
            onSubmit: ($form, params) => {
                window.location.href = `${$form.attr('action')}?${params}`;
            },
        }).bind();

        const maoModal = bindMAORedirectModal({
            $maoForm: $purchaseActions.find('.js-make-offer-form'),
            $recommendedOfferModal,
            onModalShow() {
                trackMaoModalOpen(productModel, PDPSection.PDP);
            },
            productId,
            privateDealId,
        });

        const maoRedirectKey = getMaoRedirectKey();
        if (searchParams.get(maoRedirectKey)) {
            HistoryUtils.cleanseParamFromUri(maoRedirectKey);
            maoModal?.show();
        }
    }

    bindAdminActions() {
        $('.js-download-link').on('click', (e) => {
            e.stopPropagation(); // prevent the carousel from being clicked
        });

        const $resendWhiteoutJobForm = $('.js-resend-whiteout-job-form');
        if ($resendWhiteoutJobForm.length) {
            $resendWhiteoutJobForm.on('submit', () => {
                const $whiteoutSubmitBtn = $resendWhiteoutJobForm.find('button[type="submit"]');

                // prevent double clicks
                $whiteoutSubmitBtn.prop('disabled', true);
                $whiteoutSubmitBtn.text('Sending to Bright River...');
            });
        }

        const $purgeProductImagesForm = $('.js-purge-product-images-form');
        if ($purgeProductImagesForm.length) {
            $purgeProductImagesForm.on('submit', () => {
                const $submitBtn = $purgeProductImagesForm.find('button[type="submit"]');

                // prevent double clicks
                $submitBtn.prop('disabled', true);
                $submitBtn.text('Purging images cache...');
            });
        }
    }

    /**
     * @inheritdoc
     */
    bindPageAnalytics() {
        const { product } = this;

        if (!isStaff()) {
            trackPageVisitForPRT();
        }

        //
        // Carousel Analytics
        //

        // Carousel CTAs

        const $carouselPromotionSlide = $('.js-carousel-promotion-slide');
        const carouselCtaEventProperties = {
            [AmplitudeEventProperty.POSITION]: PDPSection.CAROUSEL,
        };

        $carouselPromotionSlide.find('.js-buy-now-form').on('click', () => {
            logAmplitudeButtonClickEvent('Add To Cart', carouselCtaEventProperties);
        });

        $carouselPromotionSlide.find('.js-favorite-button').on('click', () => {
            logAmplitudeButtonClickEvent('Save To Favorites', carouselCtaEventProperties);
        });

        $carouselPromotionSlide.find('.js-make-offer-form').on('click', () => {
            logAmplitudeButtonClickEvent('Make An Offer', carouselCtaEventProperties);
        });

        // Carousel Thumbnails

        $('.js-carousel-indicator img').on('click', () => {
            logAmplitudeEvent(TrackingAction.THUMBNAIL_CLICK, {
                [AmplitudeEventProperty.POSITION]: PDPSection.THUMBNAILS,
                [AmplitudeEventProperty.PRODUCT_ID]: product.getId(),
            });
        });

        $('.js-product-badge-link').on('click', ({ currentTarget }) => {
            const $badgeLink = $(currentTarget);
            logAmplitudeClickEvent($badgeLink.text(), PDPSection.PDP, $badgeLink.attr('href'), {
                [AmplitudeEventProperty.PRODUCT_ID]: product.getId(),
            });
        });

        $('.js-seller-name-link').on('click', ({ currentTarget }) => {
            const $link = $(currentTarget);
            logAmplitudeClickEvent('seller name', PDPSection.PDP, $link.attr('href'), {
                [AmplitudeEventProperty.DISPLAY]: $link.text(),
            });
        });

        $('.js-product-hold-action-revealer').on('click', () => {
            trackHoldRequestShow(product);
        });

        $('.js-prop-65-details').on('click', () => {
            logAmplitudeEvent('prop 65 modal open', {
                [AmplitudeEventProperty.PRODUCT_ID]: product.getId(),
            });
        });

        $('.js-trade-insurance-policies').on('click', (e) => {
            logAmplitudeClickEvent(
                'extended return policies',
                PDPSection.EXTENDED_RETURN_POLICIES,
                $(e.currentTarget).attr('href'),
            );
        });

        if (this.product.getIsVariant()) {
            import('chairisher/view/product/variantdrawer').then(({ default: bindVariantDrawer }) => {
                bindVariantDrawer();
            }, handleAsyncError);
        }

        $(['#js-info-details', '#js-info-shipping', '#js-info-returns', '#js-info-trade-insurance'].join(',')).on(
            'hidden.bs.collapse shown.bs.collapse',
            (e) => {
                const sectionIdToPositionValueMap = {
                    'js-info-details': PDPSection.DETAILS,
                    'js-info-shipping': PDPSection.SHIPPING_OPTIONS,
                    'js-info-returns': PDPSection.RETURNS,
                    'js-info-trade-insurance': PDPSection.EXTENDED_RETURN_POLICIES,
                };

                const eventProperties = getAmplitudeEventPropertiesForProductDetailsSection(product);
                eventProperties[AmplitudeEventProperty.POSITION] = sectionIdToPositionValueMap[e.target.id];

                const isVisible = e.type === 'shown';
                trackContentVisibility(isVisible, sectionIdToPositionValueMap[e.target.id], eventProperties);
            },
        );

        $('.js-shipping-detail').on('click', () => {
            const eventProperties = getAmplitudeEventPropertiesForProductDetailsSection(product);
            eventProperties[AmplitudeEventProperty.POSITION] = PDPSection.SHIPPING_OPTIONS;

            const isHidden = $('#js-info-shipping').hasClass('collapse');
            trackContentVisibility(!isHidden, PDPSection.SHIPPING_OPTIONS, eventProperties);
        });

        //
        //  Sustainability Message Analytics & Tooltip
        //

        // Used to allow only two sustainability message Amplitude Events per page load
        let sustainabilityTooltipCounter = 0;
        const logSustainabilityAmplitudeEvent = () => {
            sustainabilityTooltipCounter += 1;
            if (sustainabilityTooltipCounter <= 2) {
                logSustainabilityShowEvent(product);
            }
        };

        const $shopSustainablyLink = $('.js-shop-sustainably-link');
        if (isTouchDevice()) {
            $shopSustainablyLink.on('click', (e) => {
                e.preventDefault();
                $shopSustainablyLink.tooltip({ placement: TooltipHelper.getPlacement });
                $shopSustainablyLink.tooltip('toggle');
                logSustainabilityAmplitudeEvent();
            });
        } else {
            $shopSustainablyLink.tooltip({ placement: TooltipHelper.getPlacement });
            $shopSustainablyLink.on('mouseenter', () => {
                logSustainabilityAmplitudeEvent();
            });
        }

        $('.js-breadcrumb').on('click', 'a', (e) => {
            const $currentTarget = $(e.currentTarget);
            logAmplitudeClickEvent($currentTarget.text(), GlobalPosition.BREADCRUMBS, $currentTarget.attr('href'));
        });

        $('.js-arrival-info-link').on('click', (e) => {
            const $link = $(e.currentTarget);
            logAmplitudeClickEvent('estimated arrival timeframe', PDPSection.SHIPPING_OPTIONS, $link.attr('href'), {
                [AmplitudeEventProperty.ESTIMATED_ARRIVAL_TIMEFRAME]: $link.text(),
            });
        });

        //
        // Page-specific marketing tracking pixels
        //
        if (canLoadAdvertisingCookies()) {
            const $p2rScriptEl = $('#js-p2r-rezync-script');
            if ($p2rScriptEl.length) {
                $(document.head).append($p2rScriptEl.html());
            }
        }

        //
        // PLA Link tracking
        //
        $('.js-pla-link').on('click', (e) => {
            const $currentTarget = $(e.currentTarget);
            logAmplitudeClickEvent($currentTarget.text().trim(), PDPSection.PLA_LINK, $currentTarget.attr('href'));
        });
    }

    /**
     * @inheritdoc
     */
    bindPageActions() {
        fetchProduct(this.product.getId()).then((productData) => {
            // Product data won't exist for non-public products e.g. drafts
            if (productData) {
                if (productData.meta?.shipping_location) {
                    const { country_code: countryCode, postal_code: postalCode } = productData.meta.shipping_location;
                    this.setLocationBtnInfo(countryCode, postalCode);
                    this.submitShippingOptions(postalCode);
                } else {
                    this.setLocationBtnInfo();
                }

                if (productData.meta?.private_deal) {
                    renderPrivateDeal(productData, PrivateDealSource.PDP);
                    this.product.setHasPrivateDeal(true);

                    const $offerRecommendation = $('.js-offer-recommendation');
                    $offerRecommendation.find('.js-how-offers-work-text').text('Or make a counter offer:');
                    $offerRecommendation.find('.js-submit-btn-text').text('Review counter offer');
                }

                trackProductDetailPageview(this.product, productData.meta);

                renderProductDisclaimers(productData);
                DoesShipToYou.renderDoesShipToYouOnPdp(productData);

                this.numOtherCartsIn = productData?.meta?.num_other_carts_in || 0;

                // Shows the "shoppers have this in their cart" line under price when applicable, and user is in control
                // Shows the "In x carts with y views in the last 48 hours" if user is in the treatment bucket
                const canBePurchased = productData?.meta?.should_show_purchase_buttons;
                const numViews = productData?.meta?.num_other_views_in_last_48_hrs || 0;
                const message = document.querySelector('.js-pdp-carts-urgency-message');
                if (message && canBePurchased) {
                    let hasMessageContent = false;
                    const isInPDPNumViewsVariant = isExperimentVariantB(
                        getAmplitudeExperimentFlagMap().PDP_NUM_VIEWS_CART,
                    );

                    // TODO: CHAIR-19178 Refactor after abtest
                    if (numViews > 0 && isInPDPNumViewsVariant) {
                        const numViewsStr = formatUrgencyCount(numViews);
                        let messageText = `${numViewsStr} view${numViews > 1 ? 's' : ''} in the last 48 hours.`;
                        if (this.numOtherCartsIn > 0) {
                            messageText = `${formatInNumCartsString(this.numOtherCartsIn)} with ${messageText}`;
                        }
                        message.textContent = messageText;
                        hasMessageContent = true;
                    }

                    if (this.numOtherCartsIn > 0 && !isInPDPNumViewsVariant) {
                        message.textContent =
                            this.numOtherCartsIn === 1
                                ? '1 shopper has this in their cart!'
                                : `${formatUrgencyCount(this.numOtherCartsIn)} shoppers have this in their cart!`;
                        hasMessageContent = true;
                    }

                    if (hasMessageContent) {
                        message.classList.remove('hidden');

                        // @todo CHAIR-19415 Remove after test - expose only when cart urgency is visible
                        if (this.numOtherCartsIn > 0) {
                            exposeExperiment(getAmplitudeExperimentFlagMap().ANONYMOUS_IN_NUM_CART);
                        }
                    }
                }

                this.toggleTradeInsuranceUIComponents(productData);
            }
        }, handleAsyncError);

        $('.tt').tooltip({
            placement: TooltipHelper.getPlacement,
            html: true,
            title: getTradeInsuranceProgramBenefits().join('<br/>'),
        });

        //
        // Favorites
        //

        const $favoriteAction = $('.js-favorite-action');
        const isFavorited = $favoriteAction.find('.js-favorite-button.on').length > 0;

        // if product is favorited, count will fade in immediately
        const $productFavoriteCount = $('.js-product-favorite-count');
        if ($productFavoriteCount.length > 0) {
            const favoriteCount = $productFavoriteCount.data('favorite-count');
            if (favoriteCount) {
                $productFavoriteCount.hide();
                if (prefersReducedMotion()) {
                    $productFavoriteCount.show();
                } else if (isFavorited) {
                    $productFavoriteCount.fadeIn();
                }
            }
        }

        // ensures animation only runs on load + fades in favorite count upon completion
        $favoriteAction.on('animationend', ({ currentTarget }) => {
            $(currentTarget).removeClass('wiggle-in');
            $productFavoriteCount.fadeIn();
        });

        //
        // Quantity Controls
        //
        const $quantityField = $('.js-quantity-field');
        if ($quantityField.length) {
            const quantityField = new QuantityField({
                $el: $quantityField,
                callback: (newVal) => {
                    $('.js-buy-now-form [name="quantity"]').val(newVal);
                    $quantityField.find('[name="quantity"]').val(newVal);
                    $('.js-offer-recommendation-form').data('quantity', newVal);
                    if ($('.js-shipping-option').length) {
                        const destinationPostalCode = $('.js-location-container #js-location-btn').val();
                        this.submitShippingOptions(destinationPostalCode);
                    }
                },
            });
            quantityField.bind();
        }

        //
        // Order a Sample button
        // bootstraps the "buy a sample" modal if appropriate

        new SampleDetailModal().initialize();

        //
        // Message Seller CTA
        //

        $('.js-message-user-form').on('submit', (e) => {
            e.preventDefault();

            const $form = $(e.currentTarget);
            const url = $form.attr('action');
            const productIds = encodeURIComponent(JSON.stringify([getProductId()]));

            $.ajax({
                authUrl: `${getQuickCreateUrl('private-message')}&product-ids=${productIds}`,
                data: $form.serialize(),
                type: $form.attr('method'),
                url,
            })
                .done(async (data) => {
                    const {
                        bindChannelDetailComponents,
                        bindChannelDetailPageActions,
                        bindChannelDetailPageAnalytics,
                    } = await import('chairisher/view/account/channel/detail');

                    zendeskWebWidgetInst.hideMockWidget();
                    logAmplitudeClickEvent('message seller', $form.attr('data-position'), url);
                    const $channelDetailModal = $($('.js-channel-detail-modal').html(data.html)).prepend(
                        $('<div></div>', { class: 'color-bar' }),
                    );

                    // properly clears user meta element if empty - allows css to behave corectly
                    const $userMeta = $channelDetailModal.find('.js-user-meta');
                    if (!$userMeta.text().trim().length) {
                        $userMeta.empty();
                    }

                    // binds all methods shared with the account channel detail controller
                    const position = BuyerSellerCommunicationPosition.MODAL;
                    bindChannelDetailPageAnalytics($channelDetailModal, position);
                    bindChannelDetailComponents($channelDetailModal, position);
                    bindChannelDetailPageActions($channelDetailModal);

                    // binds options for closing the modal
                    const closeModal = (shouldRedisplayWidget = true) => {
                        $channelDetailModal.fadeOut(300);
                        ViewportUtil.unlockViewport();

                        if (shouldRedisplayWidget && !isLiveChatActive()) {
                            zendeskWebWidgetInst.showMockWidget();
                        }
                    };
                    $channelDetailModal
                        .find('.js-channel-detail-back-btn, .js-close-icon')
                        .on('click', () => closeModal());
                    $channelDetailModal.find('.js-channel-support-btn').on('click', () => closeModal(false));

                    // prevents opening of new tab and instead navigates to + expands section on current page
                    $channelDetailModal.find('.js-channel-quick-link-btn').on('click', (evt) => {
                        const { hash } = evt.currentTarget;
                        if (hash) {
                            evt.preventDefault();
                            document.location.hash = hash;

                            const $sectionTitleBtn = $(hash).find('.js-section-title-btn');
                            if ($sectionTitleBtn.hasClass('collapsed')) {
                                $sectionTitleBtn.trigger('click');
                            }

                            if (isMaxMediumDesktop()) {
                                closeModal();
                            }
                        }
                    });

                    // renders the modal
                    $channelDetailModal.fadeIn(300);
                    $channelDetailModal.appendTo(document.body);

                    // scrolls to most recent message
                    const $chatInner = $channelDetailModal.find('.js-chat-inner');
                    $chatInner.scrollTop($chatInner[0].scrollHeight);

                    if (isMaxMediumDesktop()) {
                        ViewportUtil.lockViewport();
                    }
                })
                .fail((jqXHR) => {
                    if (!isUnauthorized(jqXHR.status)) {
                        renderAjaxErrorAlert(jqXHR);
                    }
                });
        });

        //
        // Seller Awards
        //

        $('.js-seller-award').popover();

        //
        // Seller Reviews
        //

        bindSellerReviews(getProductId());

        //
        // Info Display
        //

        $('.js-swap-trigger').on('click', (e) => {
            e.preventDefault();
            const $parent = $(e.currentTarget).closest('.js-swap-sibling');
            $parent.siblings('.js-swap-sibling').removeClass('hidden');
            $parent.addClass('hidden');
        });

        //
        // Buyer Guarantee Tooltip
        //

        const $buyerGuaranteeLink = $('.js-buyer-guarantee-link');
        if (isTouchDevice()) {
            $buyerGuaranteeLink.on('click', (e) => {
                e.preventDefault();
                $('#js-buyer-guarantee-modal').modal();
            });

            $('.js-learn-more-link').on('click', (e) => {
                ProductDetailController.trackBuyerGuaranteeLinkClick(e);
            });
        } else {
            $buyerGuaranteeLink.tooltip({ placement: TooltipHelper.getPlacement });
            $buyerGuaranteeLink.on('click', (e) => {
                ProductDetailController.trackBuyerGuaranteeLinkClick(e);
            });
        }

        //
        // Back Breadcrumb
        //

        $('.js-history-crumb').on('click', () => {
            if (HistoryUtils.isBackPermitted()) {
                window.history.back();
            }
        });

        //
        // Prop 65 Modal
        //

        $('.js-prop-65-details').on('click', () => {
            $('body').addClass('static-modal');
            $('#js-prop-65-modal').modal();
        });
        $('.js-modal-prop-65').on('hidden.bs.modal', () => {
            $('body').removeClass('static-modal');
        });

        //
        // view in your space CTA
        //
        if (
            (['iPad', 'iPhone'].includes(navigator.platform) || navigator.platform.includes('Mac')) &&
            isTouchDevice()
        ) {
            $('.js-viys-cta-container').removeClass('hidden');
        }
        $('.js-app-store-link').on('click', (e) => {
            const $link = $(e.currentTarget);
            logAmplitudeClickEvent($link.text(), PDPSection.SOCIAL_BAR, $link.attr('href'));
        });

        this.bindCarousel();
        if (isAuthenticated()) {
            this.bindFolderActions();
        }

        this.bindShippingOptions();
        ProductDetailController.bindProductLineProducts();
        ProductDetailController.bindTastemakerProducts();
        ProductDetailController.bindPromotedListings();
        ProductDetailController.bindCtlProducts();
        ProductDetailController.bindMltProducts();
        ProductDetailController.bindMftsProducts(); // TODO: (CHAIR-18633) Revisit after experiment
        ProductDetailController.bindYmalProducts();
        ProductDetailController.bindFeaturedNewArrivalsProducts();
        this.bindTearSheet();
        ProductDetailController.bindVariants();
        SocialShare.bind();
    }

    bindCarousel() {
        const { product } = this;
        const $carousel = $('.js-carousel');

        $.each($carousel, (i) => {
            new Carousel({
                $carousel: $carousel.eq(i),
                $carouselIndicators: $('.carousel-indicators'),
            }).bind();

            // avoids opening ImageViewer for the promotion slide
            $('.js-carousel-slide:not(.js-carousel-promotion-slide)')
                .add('.js-authenticity-mark-btn')
                .on('click', (e) => {
                    e.preventDefault();

                    const viewer = new ImageViewer({
                        favoriteTrackingLabel: TrackingLabel.PDP_IMAGE_VIEWER,
                        imageSrcsets: getImageViewerSrcsets(),
                        indicatorSrcsets: getImageViewerIndicatorSrcsets(),
                        product,
                        startIndex: $(e.currentTarget).index(),
                    });
                    viewer.show();
                });
        });
    }

    /**
     * Binds actions related to the PDP product's folders
     */
    bindFolderActions() {
        // TODO: (CHAIR-9033) refactor favorite.js so we don't need to bind to document
        $(document).on(['favorite.create', 'favorite.creating', 'favorite.deleting'].join(' '), () => {
            this.toggleFolderTrigger();
        });

        FavoriteProductView.updateFavoriteProductIds().done(() => {
            this.toggleFolderTrigger();
        });
    }

    static bindProductLineProducts() {
        const productLineUrl = getProductLineUrl();
        if (productLineUrl) {
            const productRailsArray = [];
            productRailsArray.push(
                [$('#js-pl-products-mobile'), productLineUrl],
                [$('#js-pl-products'), productLineUrl],
            );

            productRailsArray.forEach(([$productLineProducts, curatedProductLineUrl]) => {
                if ($productLineProducts.length) {
                    const railIdSelector = `#${$productLineProducts.attr('id')}`;
                    createProductRail({
                        $containerEl: $productLineProducts,
                        $el: $productLineProducts.find(`${railIdSelector}-scrollable-grid`),
                        analyticsTrackingPosition: ProductRailPosition.BOTTOM,
                        analyticsTrackingType: ProductRailType.PRODUCT_LINE,
                        listSelector: railIdSelector,
                        railUrl: curatedProductLineUrl,
                    });
                }
            });
        }
    }

    static bindPromotedListings() {
        const promotedProductsIdSelector = '#js-promoted-listings-pdp';
        createProductRail({
            $containerEl: $(promotedProductsIdSelector),
            $el: $(`${promotedProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.TOP,
            analyticsTrackingType: ProductRailType.PROMOTED_LISTINGS,
            listSelector: promotedProductsIdSelector,
            railUrl: getPromotedListingsUrl(),
        });
    }

    static bindCtlProducts() {
        // populates the ctl rail for pla pdps
        const ctlPlaProductsIdSelector = '#js-ctl-products-pla';
        createProductRail({
            $containerEl: $(ctlPlaProductsIdSelector),
            $el: $(`${ctlPlaProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.BOTTOM,
            analyticsTrackingType: ProductRailType.COMPLETE_THE_LOOK,
            listSelector: ctlPlaProductsIdSelector,
            railUrl: getCompleteTheLookUrl(),
            shouldRestrictToShipsTo: isUserInCountryWeShipTo(),
        });

        const ctlProductsIdSelector = '#js-ctl-products';
        createProductRail({
            $containerEl: $(ctlProductsIdSelector),
            $el: $(`${ctlProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.BOTTOM,
            analyticsTrackingType: ProductRailType.COMPLETE_THE_LOOK,
            listSelector: ctlProductsIdSelector,
            railUrl: getCompleteTheLookUrl(),
            shouldRestrictToShipsTo: isUserInCountryWeShipTo(),
        });
    }

    static bindMltProducts() {
        let aboveFoldIdSelector = null;
        let aboveFoldTrackingSubtype = null;
        const defaultAboveFoldSelector = '#js-mlts-above-fold';
        const organicAboveFoldSelector = '#js-organic-mlts-above-fold';
        if (ReferrerUtils.isOrganicReferrer() && $(organicAboveFoldSelector).length) {
            aboveFoldIdSelector = organicAboveFoldSelector;
            aboveFoldTrackingSubtype = ProductRailSubType.ORGANIC;
        } else if ($(defaultAboveFoldSelector).length) {
            aboveFoldIdSelector = defaultAboveFoldSelector;
        }

        if (aboveFoldIdSelector) {
            const $aboveFoldContainerEl = $(aboveFoldIdSelector);
            if ($aboveFoldContainerEl.length) {
                createProductRail({
                    $el: $(`${aboveFoldIdSelector}-scrollable-grid`),
                    $containerEl: $aboveFoldContainerEl,
                    analyticsTrackingPosition: ProductRailPosition.TOP,
                    analyticsTrackingSubtype: aboveFoldTrackingSubtype,
                    analyticsTrackingType: ProductRailType.MORE_LIKE_THIS,
                    listSelector: aboveFoldIdSelector,
                    railUrl: getMoreLikeThisUrl(),
                    shouldRestrictToShipsTo: isUserInCountryWeShipTo(),
                });
            }
        }

        if (!ReferrerUtils.isOrganicReferrer()) {
            const mltIdSelector = '#js-mlt-products';
            const $mltContainerEl = $(mltIdSelector);
            if ($mltContainerEl.length) {
                createProductRail({
                    $el: $(`${mltIdSelector}-scrollable-grid`),
                    $containerEl: $mltContainerEl,
                    analyticsTrackingPosition: ProductRailPosition.BOTTOM,
                    analyticsTrackingType: ProductRailType.MORE_LIKE_THIS,
                    listSelector: mltIdSelector,
                    railUrl: getMoreLikeThisUrl(),
                    shouldRestrictToShipsTo: isUserInCountryWeShipTo(),
                });
            }
        }
    }

    static bindTastemakerProducts() {
        if (getTastemakerUrl()) {
            const tastemakerProductsIdSelector = '#js-tastemaker-products';
            createProductRail({
                $containerEl: $(tastemakerProductsIdSelector),
                $el: $(`${tastemakerProductsIdSelector}-scrollable-grid`),
                analyticsTrackingPosition: ProductRailPosition.BOTTOM,
                analyticsTrackingType: ProductRailType.TASTEMAKER,
                listSelector: tastemakerProductsIdSelector,
                railUrl: getTastemakerUrl(),
            });
        }
    }

    static bindMftsProducts() {
        // TODO: (CHAIR-18633) Revisit after experiment
        const mftsRailPdpFlag = getAmplitudeExperimentFlagMap().MFTS_RAIL_PDP;
        const isInCategorySortVariant = isExperimentVariantB(mftsRailPdpFlag);

        if (isInCategorySortVariant || isExperimentVariantC(mftsRailPdpFlag)) {
            const mftsUrl = getMoreFromThisSellerUrl();
            ['#js-mfts-products-pla', '#js-mfts-products'].forEach((listSelector) => {
                const $containerEl = $(listSelector);
                if ($containerEl.length && mftsUrl) {
                    createProductRail({
                        $containerEl,
                        $el: $(`${listSelector}-scrollable-grid`),
                        analyticsTrackingPosition: ProductRailPosition.BOTTOM,
                        analyticsTrackingType: ProductRailType.MORE_FROM_THIS_SELLER,
                        listSelector,
                        railUrl: isInCategorySortVariant ? `${mftsUrl}&mfts_sort=category` : mftsUrl,
                        shouldRestrictToShipsTo: isUserInCountryWeShipTo(),
                    });
                }
            });
        }
    }

    static bindYmalProducts() {
        // populates the ymal rail for pla pdps
        const ymalPlaProductsIdSelector = '#js-ymal-products-pla';
        createProductRail({
            $containerEl: $(ymalPlaProductsIdSelector),
            $el: $(`${ymalPlaProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.BOTTOM,
            analyticsTrackingType: ProductRailType.YOU_MAY_ALSO_LIKE,
            listSelector: ymalPlaProductsIdSelector,
            railUrl: getYmalUrl(),
            shouldRestrictToShipsTo: isUserInCountryWeShipTo(),
        });

        const ymalProductsIdSelector = '#js-ymal-products';
        createProductRail({
            $containerEl: $(ymalProductsIdSelector),
            $el: $(`${ymalProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.BOTTOM,
            analyticsTrackingType: ProductRailType.YOU_MAY_ALSO_LIKE,
            listSelector: ymalProductsIdSelector,
            railUrl: getYmalUrl(),
            shouldRestrictToShipsTo: isUserInCountryWeShipTo(),
        });
    }

    static bindFeaturedNewArrivalsProducts() {
        const featuredProductsIdSelector = '#js-featured-new-arrivals-products';
        createProductRail({
            $containerEl: $(featuredProductsIdSelector),
            $el: $(`${featuredProductsIdSelector}-scrollable-grid`),
            analyticsTrackingPosition: ProductRailPosition.BOTTOM,
            analyticsTrackingType: ProductRailType.PROMOTED_LISTINGS,
            listSelector: featuredProductsIdSelector,
            railUrl: getPromotedListingsUrl(),
        });
    }

    async submitShippingOptions(destinationPostalCode) {
        const $locationContainer = $('.js-location-container');
        const $errorList = $locationContainer.find('.js-error-list');
        const $arrivalInfoLink = $('.js-arrival-info-link');
        const $relatedProductsLink = $('.js-related-products-link');

        const { product } = this;

        $locationContainer.removeClass('has-error');
        $errorList.empty();
        syncListAriaHidden($errorList[0]);

        const shippingParams = new URLSearchParams({
            destination_postal_code: destinationPostalCode,
            quantity: parseInt($('.js-quantity-field-input').val(), 10) || 1,
        });

        let shippingData = {};
        try {
            shippingData = await getJSON(`${getShippingOptionsUrl()}?${shippingParams}`);
        } catch {
            shippingData = { errors: [{ display: 'Unable to find shipping options. Please try again later.' }] };
        }

        let shippingOptions = shippingData.shipping_options || [];
        if (shippingData.help_text || shippingData.errors) {
            shippingOptions = [];
        }

        const options = shippingOptions.map((shippingOption) => {
            if ($arrivalInfoLink.length && shippingOption.is_preferred) {
                const hasArrivalTimeframe = !!shippingOption.estimated_arrival_timeframe;
                $('.js-product-ships-from').toggleClass('colon-after', hasArrivalTimeframe);
                $arrivalInfoLink.toggleClass('hidden', !hasArrivalTimeframe);
                $arrivalInfoLink.text(shippingOption.estimated_arrival_timeframe);

                this.product.setEstimatedArrivalTimeframe(shippingOption.estimated_arrival_timeframe);
                this.product.setShippingCost(shippingOption.price);
                this.product.setShippingDistance(shippingOption.distance);
                this.product.setShippingPartnerCode(shippingOption.value);
            }

            return ShippingOptionField.marshal(shippingOption);
        });

        $('#js-shipping-partner-codes').html(options);

        if (shippingData.errors) {
            $errorList.html(FormFieldComponent.marshalMessageList(shippingData.errors));
            syncListAriaHidden($errorList[0]);
            $locationContainer.addClass('has-error');
            DoesShipToYou.hideDoesShipToMeMessaging();
        }

        if (shippingData.similar_products_url && shippingData.similar_products_text) {
            $relatedProductsLink.attr('href', shippingData.similar_products_url);
            $relatedProductsLink.text(shippingData.similar_products_text);
        }

        // Postal code is valid and shipping options are available
        if (shippingOptions.length && !shippingOptions[0].is_unavailable) {
            const primaryShippingOption = shippingOptions[0];
            product.setShippingCost(primaryShippingOption.price);
            product.setShippingDistance(primaryShippingOption.distance);
            product.setShippingPartnerCode(primaryShippingOption.value);
            trackProductShippingChanged(product, primaryShippingOption.pre_adjusted_price);
            DoesShipToYou.showShippingOptions();
        }

        const doesNotShipToYouText = shippingData.help_text?.[0]?.display;
        if (doesNotShipToYouText) {
            DoesShipToYou.hideShippingOptions();
            $('.js-does-not-ship-to-location-message').text(doesNotShipToYouText);
        }
    }

    bindShippingOptions() {
        //
        // Shipping info modal
        //

        $('.js-more-returns-info').on('click', () => $('#js-returns-modal').modal());

        //
        // Shipping Options
        //

        // Location Popover
        const $locationBtn = $('.js-location-btn');

        const locationPopover = new LocationPopover({ $el: $locationBtn });
        locationPopover.bind();

        $locationBtn.on('click', (e) => {
            e.preventDefault();
            locationPopover.setCountryCode($locationBtn.data('country-code'));
            locationPopover.setPostalCode($locationBtn.val());
            locationPopover.show();
        });

        $locationBtn.on(
            LocationPopoverEvents.SUCCESS,
            async (_, { country_code: countryCode, postal_code: postalCode }) => {
                this.setLocationBtnInfo(countryCode, postalCode);
                locationPopover.unbind();
                locationPopover.hide();
                trackLocationSearchEvent(postalCode, TrackingScreen.PDP);

                try {
                    // Re-fetch product data and shipping - product response can change because session has new postal code
                    const [productData] = await Promise.all([
                        fetchProduct(this.product.getId()),
                        this.submitShippingOptions(postalCode),
                    ]);

                    if (productData) {
                        renderProductDisclaimers(productData);
                        this.toggleTradeInsuranceUIComponents(productData);
                    }
                } catch (error) {
                    handleAsyncError(error);
                }
            },
        );

        $locationBtn.on(LocationPopoverEvents.ERROR, (_, { message: errorMessage }) => {
            const $postalCodeFormGroup = $(document.body)
                .find('.js-location-popover [name="postal_code"]')
                .closest('.js-form-group');
            FormUtils.setFormGroupErrorMessage($postalCodeFormGroup, errorMessage);
        });

        // Related Products
        const $relatedProductsLink = $('.js-related-products-link');
        $relatedProductsLink.on('click', () => {
            logAmplitudeClickEvent(
                $relatedProductsLink.text().trim(),
                PDPSection.VIEW_MORE_NEAR_YOU,
                $relatedProductsLink.attr('href'),
            );
        });

        $('.js-shipping-option-title-tooltip').tooltip({ placement: TooltipHelper.getPlacement });
    }

    bindTearSheet() {
        const { product } = this;
        /**
         * Print or download the tear sheet for this product
         *
         * @param {Event} e The event triggering the tear sheet action
         */
        const getTearSheet = (e) => {
            const $action = $(e.currentTarget);
            const action = $action.attr('download') ? TrackingAction.DOWNLOAD : TrackingAction.PRINT;

            logAmplitudeEvent(`dealer - ${action} tear sheet`, {
                [AmplitudeEventProperty.DEALER_GUID]: product.getDealerGuid(),
                [AmplitudeEventProperty.PRODUCT_ID]: product.getId(),
                [AmplitudeEventProperty.PRODUCT_PRICE]: product.getPrice(),
                [AmplitudeEventProperty.IS_PRICE_HIDDEN]: false,
                [AmplitudeEventProperty.IS_NEWLY_MADE]: product.getIsNewlyMade(),
            });

            window.location = $action.attr('href');
        };

        $('.js-product-tear-sheet-actions').on('click', 'a', (e) => {
            e.preventDefault();

            if (
                // Bypass auto-favoriting logic
                isStaff() ||
                getGuid() === product.getDealerGuid() ||
                FavoriteProductView.isProductIdFavorited(product.getId())
            ) {
                getTearSheet(e);
            } else {
                $.ajax({
                    authUrl: `${getQuickCreateUrl('tear-sheet-request')}&is_sign_up=0`,
                    url: `${getFavoriteCreateUrl(product.getId())}?tracking_create_type=tear_sheet`,
                    method: 'POST',
                })
                    .done(() => {
                        FavoriteProductView.updateFavoriteProductIds().done(() => {
                            FavoriteProductView.drawButtons();
                            this.toggleFolderTrigger();
                            getTearSheet(e);
                        });
                    })
                    .fail((jqXHR) => {
                        // If user is not logged in, they will be prompted to log in via a modal so that the auto-favoriting
                        // logic described in CHAIR-9610 can take effect. Per that ticket, if the user opts not to log in by
                        // closing the modal, allow them to access the tear sheet anyway.
                        if (!isAuthenticated() && isUnauthorized(jqXHR.status)) {
                            getTearSheet(e);
                        }
                    });
            }
        });
    }

    static bindVariants() {
        const $variants = $('.js-variants');

        if ($variants.length && !isTouchDevice()) {
            const $defaultText = $variants.find('.js-product-options-available');
            const $selectedTitle = $variants.find('.js-variant-title');
            const $selectedPrice = $variants.find('.js-variant-price');
            const $selectedDimensions = $variants.find('.js-variant-dimensions');

            const $variantProducts = $variants.find('.js-product');

            $variantProducts.on('mouseover', (e) => {
                const variantData = getDataForVariantId($(e.currentTarget).data('product-id'));
                if (variantData) {
                    $defaultText.hide();
                    $selectedTitle.text(variantData.title);
                    $selectedPrice.text(variantData.price);
                    $selectedDimensions.text(variantData.dimensions);
                } else {
                    $defaultText.show();
                }
            });

            $variantProducts.on('mouseout', () => {
                $selectedTitle.text('');
                $selectedPrice.text('');
                $selectedDimensions.text('');
                $defaultText.show();
            });
        }
    }

    /**
     * Set user's location data in Shipping Options section of PDP
     * @param {string} countryCode user's country code
     * @param {string} postalCode user's postal code
     */
    setLocationBtnInfo(countryCode = '', postalCode = '') {
        const $locationBtn = $('.js-location-btn');
        if (countryCode && postalCode) {
            const countryName = getShippableCountryByCode(countryCode).display;
            $locationBtn.data('country-code', countryCode);
            $locationBtn.text(`${postalCode}, ${countryName}`);
            $locationBtn.val(postalCode);
        } else {
            $locationBtn.text('Enter your location');
        }
    }

    /**
     * Toggles the folder trigger depending on whether the product is favorited and the user is logged in
     */
    toggleFolderTrigger() {
        if (this.folderCardMenu?.hasFolderTrigger()) {
            this.folderCardMenu.removeFolderTrigger();
        }

        const productId = getProductId();
        if (FavoriteProductView.isProductIdFavorited(productId) && isAuthenticated()) {
            if (!this.folderCardMenu) {
                this.folderCardMenu = new FolderCardMenu({
                    animation: FolderCardTransitionAnimations.append,
                    analyticsTrackingPosition: PDPSection.PDP,
                    productId,
                });
            }

            this.folderCardMenu
                .marshalFolderTrigger()
                .insertAfter('.js-product-detail .js-quick-buttons .js-favorite-action');

            this.folderCardMenu.bind();
        }
    }

    /**
     * Toggles the trade insurance ui components
     *
     * @param {object} productData A data object that contains product data information
     */
    toggleTradeInsuranceUIComponents(productData) {
        const isEligibleForTradeInsurance = productData?.meta?.is_eligible_for_trade_insurance;
        $('.js-info-returns-subheader').toggleClass('hidden', !isEligibleForTradeInsurance);
        $('.js-trade-insurance-benefits-section').toggleClass('hidden', !isEligibleForTradeInsurance);
    }

    /**
     * Sends analytics data related to the buyer guarantee link
     * @param {Event} e the event that called this function
     * @private
     */
    static trackBuyerGuaranteeLinkClick(e) {
        const $link = $(e.currentTarget);

        logAmplitudeClickEvent('Buyer Guarantee', PDPSection.PDP, $link.attr('href'));
    }
}

export default ProductDetailController;
